<template>
  <div class="unidata-editor" style="padding: 3px">
    <div class="row mr-0">
      <div class="col-8">
        <label v-tooltip="uniToolTipTranslation('TRNSL197', 'en-US')" class="label-picker">
          {{ uniTranslation("TRNSL197") }}</label
        >
      </div>
      <div v-if="noLabel === true" class="unidata-item-container col-4">
        <el-select v-model="selectedStep" placeholder="..." filterable class="form-control">
          <el-option
            v-for="item in platesNumberList"
            :key="item"
            :label="uniTranslation(item)"
            :value="item"
          ></el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Select, Option } from "element-ui";
import jsonHelper from "../../shared/jsonHelper";

export default {
  name: "PhePlatesNumberPicker",
  components: {
    "el-select": Select,
    "el-option": Option
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    },
    noLabel: Boolean
  },
  data() {
    return {
      platesNumberList: [],
      selectedStep: "",
      path: "",
      unsubscribes: []
    };
  },
  computed: {
    ...mapGetters("_translationModule", ["currentLanguage", "languages"]),
    ...mapGetters("_prjModule", ["isSaldobrasata", "projects", "isVerifica"]),
    ...mapGetters("_geometryModule", ["stepList"])
  },
  watch: {
    stepList: function() {
      if (this.stepList.length > 1) {
        this.selectedStep = jsonHelper.getProperty(
          this.projects,
          this.parentPath + ".numberOfPlates.input.usrValue.value"
        );
        var index = this.stepList.indexOf(this.selectedStep + "");
        if (index == -1) {
          index = 0;
        }
        this.platesNumberList = this.stepList;
        this.selectedStep = this.platesNumberList[index];
      }
    },
    selectedStep: function() {
      var that = this;

      var unidato = jsonHelper.getProperty(that.projects, that.path);

      unidato.input.usrValue.value = parseInt(that.selectedStep);
      unidato.input.refValue.value = parseInt(that.selectedStep);

      that.changeProperty({
        path: that.path,
        value: unidato
      });
    }
  },
  mounted: function() {
    var that = this;

    if (that.parentPath && that.localPath) that.path = that.parentPath + that.localPath;

    //that.setPlatesNumber();
  },
  methods: {
    ...mapActions("_pressuresModule", ["getPressuresListAction"]),
    ...mapActions("_prjModule", ["changeProperty"])
  }
};
</script>

<style lang="scss">
.plateNumberSelectLabel {
  margin-top: 5px;
  //padding-left: 5px;
}
.plateNumberSelect {
  width: 100%;
  margin-bottom: 10px;
  margin-top: 5px;
  padding: 0 5px;
  .el-input {
    .el-input__inner {
      height: 30px;
    }
  }
}

.label-picker {
  margin-top: 9px;
  margin-bottom: 0px;
}

.plateNumberSelectRow {
  margin-right: 0px;
  margin-left: 0px;
  .col-3 {
    padding-right: 0px;
    padding-left: 0px;
  }
  .col-9 {
    padding-right: 0px;
    padding-left: 0px;
  }
}
</style>
